import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { Button } from './button';
const useStyles = createUseStyles(theme => ({
  root: {
    position: 'relative',
    height: '1.5em',
    width: '1.5em',
    color: theme.colors['color-text-default'],
    borderRadius: theme.SHAPE.CIRCULAR,
    '&:hover': {
      backgroundColor: theme.colors['palette-grey-light-300']
    },
    '&:not(:disabled)': {
      cursor: 'pointer',
      '&:hover, &:focus': {
        color: theme.colors['palette-grey-dark-400']
      }
    },
    '&:disabled': {
      color: theme.colors['palette-grey-dark-200']
    },
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '2px',
      height: '70%',
      backgroundColor: 'currentColor'
    },
    '&:before': {
      transform: 'translate(-50%, -50%) rotate(45deg)'
    },
    '&:after': {
      transform: 'translate(-50%, -50%) rotate(-45deg)'
    }
  }
}));
export const CloseButton = props => {
  const {
    className: classNameProp,
    classes: classesProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    type: "button",
    className: className
  }, rest));
};
export default CloseButton;